import { queryOptions } from "@tanstack/react-query";

import { api } from "@platform/core/api";
import type { ApiKey } from "./api-keys.types";

// The server orders the rows, newest first. Create, revoke and delete invalidate
// this shared key to refetch.
export const apiKeysQueryOptions = queryOptions({
	queryKey: ["api-keys"],
	queryFn: () => api.get<ApiKey[]>("/platform/keys"),
});
